import React from 'react'
import { connect } from 'react-redux'
import { Flex, Box } from 'reflexbox'
import * as BP from '@blueprintjs/core'
import ContactCard from './ContactCard'
import TeamCard from './TeamCard'
import SupplierCard from './SupplierCard'
import ContactDialog, { getContactData } from './ContactDialog'
import * as contactModules from 'src/store/modules/cmdb/contacts'
import * as teamModules from 'src/store/modules/cmdb/teams'
import * as supplierModules from 'src/store/modules/cmdb/suppliers'
import { setCmdbImportContactType } from 'src/store/modules/cmdb/misc'
import './style.scss'

class Contacts extends React.Component {
    fetchCards = (query) => {
        const { contactType } = this.props
        if (contactType === 'teams') {
            this.props.getCmdbTeams(query)
        } else if (contactType === 'users') {
            this.props.getCmdbContacts(query)
        } else if (contactType === 'suppliers') {
            this.props.getSuppliers()
        }
    }
    componentDidMount() {
        this.fetchCards()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.contactType !== this.props.contactType) {
            this.fetchCards()
        }
    }

    handleEditClick = (contact) => () => {
        this.setState(getContactData(contact))
        this.props.openModal()
    }

    renderCards() {
        const {
            contacts,
            contactsLoading,
            teams,
            teamsLoading,
            contactType,
            suppliers,
            suppliersLoading,
        } = this.props
        if (contactType === 'teams') {
            if (teamsLoading) return <BP.Spinner className="cmdb-import-item" />
            if (teams.length === 0)
                return <h1 className="cmdb-import-item">No teams found.</h1>
            return teams.map((team) => (
                <Box w={1 / 4} p={2} key={team.id}>
                    <TeamCard team={team.id} />
                </Box>
            ))
        } else if (contactType === 'users') {
            if (contactsLoading)
                return <BP.Spinner className="cmdb-import-item" />
            if (contacts.length === 0)
                return <h1 className="cmdb-import-item">No contacts found.</h1>
            return contacts.map((contact) => (
                <Box w={1 / 6} p={2} key={contact.id}>
                    <ContactCard contact={contact.id} />
                </Box>
            ))
        } else if (contactType === 'suppliers') {
            if (suppliersLoading)
                return <BP.Spinner className="cmdb-import-item" />
            if (suppliers.length === 0)
                return <h1 className="cmdb-import-item">No suppliers found.</h1>
            return suppliers.map((supplier) => (
                <Box w={1 / 6} p={2} key={supplier.id}>
                    <SupplierCard supplier={supplier.id} />
                </Box>
            ))
        }
    }

    render() {
        const { contactType, modalOpen } = this.props
        return (
            <Flex wrap w={1}>
                <Box p={10} m={2} className="contact-import-controls" w={1}>
                    <Flex w={1}>
                        {/* <Box>
                        <ButtonGroup>
                            <Button
                                text="Select All"
                                // onClick={() => toggleAll(true)}
                            />
                            <Button
                                text="Clear Selection"
                                // onClick={() => toggleAll(false)}
                            />
                        </ButtonGroup>
                        <span className="contact-import-counter">{contacts.length} contacts</span>
                    </Box> */}
                        <Box>
                            <BP.ButtonGroup>
                                <BP.Button
                                    text="Teams"
                                    active={contactType === 'teams'}
                                    onClick={() =>
                                        this.props.toggleContactType('teams')
                                    }
                                />
                                <BP.Button
                                    text="Users"
                                    active={contactType === 'users'}
                                    onClick={() =>
                                        this.props.toggleContactType('users')
                                    }
                                />
                                <BP.Button
                                    text="Suppliers"
                                    active={contactType === 'suppliers'}
                                    onClick={() =>
                                        this.props.toggleContactType(
                                            'suppliers'
                                        )
                                    }
                                />
                            </BP.ButtonGroup>
                        </Box>
                        {contactType === 'suppliers' && (
                            <Box ml={2}>
                                <BP.Button
                                    text="New Contact"
                                    icon="plus"
                                    onClick={() => this.props.openModal()}
                                />
                            </Box>
                        )}
                        {modalOpen && <ContactDialog />}
                        <Box w={1 / 4} ml="auto">
                            {contactType !== 'suppliers' && (
                                <BP.InputGroup
                                    onChange={(e) =>
                                        this.fetchCards(e.target.value)
                                    }
                                    round
                                    leftIcon="search"
                                    fill
                                    placeholder="Start typing a team name"
                                />
                            )}
                        </Box>
                    </Flex>
                </Box>
                {this.renderCards()}
            </Flex>
        )
    }
}

export default connect(
    (state) => ({
        contacts: contactModules.getContactsSearchResults(state),
        selectedContacts: contactModules.getContactsForImport(state),
        contactsLoading: state.cmdb.contacts.loading,
        teams: teamModules.getTeamSearchResults(state),
        selectedTeams: teamModules.getTeamsForImport(state),
        teamsLoading: state.cmdb.teams.loading,
        suppliers: supplierModules.getSuppliers(state),
        suppliersLoading: state.cmdb.suppliers.loading,
        modalOpen: state.cmdb.suppliers.modalOpen,
        contactType: state.cmdb.misc.cmdbImportContactType,
    }),
    {
        toggleAll: contactModules.toggleAllContactsForImport,
        getCmdbContacts: contactModules.getCmdbContacts,
        getCmdbTeams: teamModules.getCmdbTeams,
        getSuppliers: supplierModules.getSuppliersFromServer,
        openModal: supplierModules.openSupplier,
        toggleContactType: setCmdbImportContactType,
    }
)(Contacts)
